module.exports = __webpack_public_path__ + "img/26.a90b3d6d.jpg";